import { MONTHLY_COMMISSIONS_ENDPOINT } from '../../endpoints'
import axios from 'axios'

export async function getPaginatedCommissions(query) {
    let search = query.search.replace('submit_button,cancel_button,','')
    const response = await axios.get(`${MONTHLY_COMMISSIONS_ENDPOINT}${search}`);
    return response.data
}